module.exports = __webpack_public_path__ + "static/media/bts_lalela_170704_001_small.f30b4390.jpg";